import ConfirmationButtons from "@/common/ConfirmationButtons";
import { Container } from "@/common/ui/container";
import OTPInputBox from "@/common/ui/otp/OTPInputBox";
import ResendOTP from "@/common/ui/otp/ResendOTP";
import { privateResendCode, verifyPhone } from "@/services/common/security.services";
import { toastMessage } from "@/utils/helper/myToast";
import React, { useState } from "react";

interface VerifyPhoneNumberProps {
  onClose: (props?: any) => void;
  verifyData: any;
}

const VerifyPhoneNumber: React.FC<VerifyPhoneNumberProps> = ({ onClose, verifyData }) => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [resetCount, setResetCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleVerify = async () => {
    setIsLoading(true);
    try {
      const res: any = await verifyPhone({ otp, token: verifyData.phoneVerifyToken });
      if (res?.status === 200) {
        const { message, isError } = res.data;
        onClose();
        return toastMessage(message, isError);
      } else if (res?.response?.status === 401) {
        const { message } = res?.response?.data || {};
        setError(message);
        return;
      } else {
        console.log("Error", res);
        const { message } = res?.response?.data || {};
        if (message) {
          setError(message);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };
  const resendOtp = async () => await privateResendCode({ token: verifyData.phoneVerifyToken });

  return (
    <Container.ContentBox>
      <Container.Content>
        <p className=" text-center py-5 text-13 text-text-label">
          We have sent a code to <span className="font-medium">{verifyData?.maskIdentity}</span>. <br />
          Please enter it below.
        </p>
        <OTPInputBox resetCount={resetCount} setCompleteOtp={setOtp} errorMessage={error} resetErrorMessage={() => setError("")} />
        <ResendOTP resendOtpAPI={resendOtp} setResetCount={setResetCount} errorMessage={error} resetErrorMessage={() => setError("")} />
      </Container.Content>
      <Container.Separator />
      <ConfirmationButtons handleConfirm={handleVerify} handleCancel={onClose} confirmText="Verify" disabled={otp.length < 6} isLoading={isLoading} />
    </Container.ContentBox>
  );
};

export default VerifyPhoneNumber;
